var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeumitSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leumit_New_Logo",
    "data-name": "Leumit_New_Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.671,12.516C8.827,14.048,5.235,12.26,2.308,8.8S.071,0,.071,0,5.506.255,8.433,3.712s4.082,7.271,2.238,8.8",
    transform: "translate(4.352 3.269)",
    fill: "#b3d337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M4,16.337c2.407,0,4-3.657,4-8.169S4,0,4,0,0,3.657,0,8.168s1.591,8.169,4,8.169",
    transform: "translate(9.682)",
    fill: "#b3d337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.89,12.516C2.734,14.049,6.326,12.26,9.253,8.8S11.49,0,11.49,0,6.055.255,3.128,3.712-.954,10.983.89,12.516",
    transform: "translate(11.447 3.269)",
    fill: "#b3d337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M0,3.187A8.886,8.886,0,0,1,.628,0,9,9,0,0,1,3.1,2C6.031,5.455,7.185,9.27,5.341,10.8a2.442,2.442,0,0,1-1.462.547C1.539,11.23,0,7.623,0,3.187",
    transform: "translate(9.682 4.982)",
    fill: "#12b24b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M6.231,3.187A8.9,8.9,0,0,0,5.6,0,9.01,9.01,0,0,0,3.128,2C.2,5.455-.954,9.27.89,10.8a2.444,2.444,0,0,0,1.463.547c2.34-.12,3.878-3.727,3.878-8.163",
    transform: "translate(11.447 4.982)",
    fill: "#12b24b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M2.229,11.708.554,7.309C-.629,5.8.154,2.879,2.229,0,4.3,2.879,5.086,5.8,3.9,7.309Z",
    transform: "translate(11.451 8.126)",
    fill: "#048d4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M0,9.949C-.084,7.334,1.649,4.27,4.689,2.162s6.538-2.674,8.988-1.7a17.32,17.32,0,0,0-7.929,3.2A17.118,17.118,0,0,0,0,9.949",
    transform: "translate(13.683 10.051)",
    fill: "#0d61ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M13.675,9.949c.087-2.615-1.647-5.679-4.686-7.787S2.45-.513,0,.463a17.321,17.321,0,0,1,7.929,3.2,17.12,17.12,0,0,1,5.745,6.289",
    transform: "translate(0 10.051)",
    fill: "#0d61ae"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeumitSmallLogo);
export default __webpack_public_path__ + "static/media/LeumitSmallLogo.07d9dbdcc2fed187381ec17d8f362999.svg";
export { ForwardRef as ReactComponent };